import axios from 'axios';
import { BASE_URL, CONTENT_API_PATH, SEASON_API_PATH } from 'constants/api';
import { ContentRelayRequest, ContentRelayResponse, SeasonContentsResponse } from '../type/contentRelayType';

const CONTENT_RELAY_API_PATH = `${CONTENT_API_PATH}relay/`;

class ContentRelayService {
  public async relay(data: ContentRelayRequest): Promise<ContentRelayResponse> {
    const response = await axios.post<ContentRelayResponse>(
      `${BASE_URL}${CONTENT_RELAY_API_PATH}`,
      data
    );
    return response.data;
  }

  public async fetchSeasonContents(
    seasonId: number,
    page: number = 1,
    pageSize: number = 20
  ): Promise<SeasonContentsResponse> {
    const response = await axios.get<SeasonContentsResponse>(
      `${BASE_URL}${SEASON_API_PATH}${seasonId}/contents/`,
      { params: { page, page_size: pageSize, order_by: 'id', order_direction: 'desc' } }
    );
    return response.data;
  }
}

export const contentRelayService = new ContentRelayService();
